import styled from "styled-components";
import { MAX_BODY_SIZE } from "../ReviewBoardFlow/ReviewBoardFlowStyles";
import { COLORS } from "../../constants/Styles";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  align-items: center;
  flex-grow: 1;
  max-width: ${MAX_BODY_SIZE};
`;

export const SelectParent = styled.div`
  width: fit-content;
`;

export const GentleText = styled.div`
  color: ${COLORS.secondary};
`;

export const AlertText = styled.div`
  display: flex;
  justify-content: center;
  gap: 0.5rem;
`;

export const AlertContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  gap: 0.5rem;
`;

export const SVGViewerParent = styled.div`
  width: 100%;
  height: 20rem;
`;
